import Action from '../Action'
import './styles/ModalSelectTech.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../LoadSimple';
import InputAdmin from '../InputAdmin';
import { useFetch } from '../../hooks/useFetch';
import SelectorAdmin from '../SelectorAdmin';
import search from '../generales/Search'
import Search from '../generales/Search';
import { capitalizeFirstLetter } from '../../utils/utils';
import { lang } from '../generales/traduction';
const ModalSelectTech =({languaje,mode,server,dataTech,setDataTech,selectedUser,selectedType,closCreateServiceModal,getRoles})=>{
  const [loading,setLoading]=useState(false);

  const [actualTech,setActualTech]=useState({data:[],loading:true,error:''})
  // const tec_list=useFetch('cassia/ci_elements/technologies','','','GET',server)
  const [msgError,setMsgError]=useState("")
  const [listSearchIP,setListSearchIP]=useState(false)
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? dataTech.data.data : searchResults;
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    // setSearchResult(`Resultados para: ${query}`);
  };

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [selectedActualCheckboxes, setSelectedActualCheckboxes] = useState([]);
  const handleSelectAll = (event) => {
    if (event.target.checked ) {
      const allCheckboxes = dataList.map((element) => element.cassia_tech_id);
      setSelectedCheckboxes(allCheckboxes);
    } else {
      setSelectedCheckboxes([]);
    }
  };
  const handleCheckboxChange = (rol_id) => {
    setSelectedCheckboxes((prevSelected) =>
      prevSelected.includes(rol_id)
        ? prevSelected.filter((id) => id !== rol_id)
        : [...prevSelected, rol_id]
    );
  };
  useEffect(()=>{
    getTech()
  },[])

  useEffect(()=>{
    if(selectedActualCheckboxes.length!=0){
      setSelectedCheckboxes(selectedActualCheckboxes[0].techs.map(obj => obj.cassia_tech_id))
    }
  },[selectedActualCheckboxes])
  const getTech=()=>{
    setActualTech({data:dataTech.data,loading:true,error:''})
    const fetchDataPost = async () => {
      
   try {
     const response = await fetch(server.url+'/api/v1/cassia/user/notifications/'+selectedUser.user_id, {
       method: 'GET',  
       headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
       },
     });

     if (response.ok) {
       const data1 = await response.json();
       setActualTech({data:data1,loading:false,error:''})
       setSelectedActualCheckboxes(data1.data.notifications.filter(obj => obj["cassia_user_notification_type_id"] === selectedType.cassia_notification_type_id))
     } else {
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
        setActualTech({data:dataTech.data,loading:false,error:''})
        console.error(error);
      }
    };

    fetchDataPost();
  }

  const Registrar=()=>{
    const type_id=selectedType.cassia_notification_type_id
    var tipos=actualTech.data.data.notifications.map(obj=>obj.cassia_user_notification_type_id)


    var final_tech=[]
    for(let i=0;i<tipos.length;i++){
     // console.log(actualTech.data.data.notifications[i].techs.map(obj=>obj.cassia_tech_id))
     if(actualTech.data.data.notifications[i].cassia_user_notification_type_id==type_id){
       final_tech.push(selectedCheckboxes)
     }else{
       final_tech.push(actualTech.data.data.notifications[i].techs.map(obj=>obj.cassia_tech_id))
     }
     
    }

    if(!tipos.includes(type_id)){
     tipos.push(type_id)
     final_tech.push(selectedCheckboxes)
    }


    const data={
     "user_id": selectedUser.user_id,
     "cassia_notification_type_id": tipos,
     "cassia_tech_id": final_tech
   }

    const fetchDataPost = async () => {
        setLoading(true)
      try {
        const response = await fetch(server.url+'/api/v1/cassia/user/notifications/techs', {
          method: 'PUT',  
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          body: JSON.stringify(data),
        });
        if (response.ok) {
          setLoading(false)
          const data1 = await response.json();
          getRoles()
          closCreateServiceModal(false)
        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {
             // setUserData({name:"",description:"",permissions:""})
             // setPermisos([])
             // setDataPermisos({data:dataPermisos.data,loading:false,error:''})
    
           console.error(error);
         }
       };

    fetchDataPost();
  }
  return(
      <div className="modal-GS-content">
          <div className='card-modal-gs modal-verificate'>
              <div className='head-card-modal-gs'>
                  <div className='title-head-card-modal-gs'>
                      {lang[languaje]['seleccionar'].toUpperCase()+"  "+lang[languaje]['tecnologias'].toUpperCase()}
                  </div>
              </div>
              <div className='content-card-users' >
                  <div className='body-cont-NotifiTech'>
                      <div className='top-content'>
                          <div className='field-content'>
                          <div className='field-element' style={{width:'20%'}}>
                                          <input
                                                type='checkbox'
                                                className={`NotifiCheckBox noti1 `}
                                                checked={selectedCheckboxes.length === dataTech.data.data.length}
                                                onChange={handleSelectAll}
                                              />
                                          </div>
                                          <div className='field-element'style={{width:'65%'}}>
                                          {lang[languaje]['seleccionar']+"  "+lang[languaje]['todos']}
                                          </div>
                          </div>
                          <div className='field-content'>
                          <Search
                  searchResults={searchResults}
                  setSearchResults={setSearchResults}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  onSearch={handleSearch}
                  dataObject={dataTech.data.data}
                  setDataObject={setDataTech}
                  languaje={languaje}
                  mode={mode}
                />
                          </div>
                      </div>
                      <div className='center-content'>
                          <div className='table-tech'>
                          
                              {
                                  (actualTech.loading)?<div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}><LoadSimple></LoadSimple></div>:
                                  dataList.map((element,index)=>(
                                      <div className={"row-table-portafolio"+mode}>
                                          <div className='field-element' style={{width:'20%'}}>
                                          <input
                                                type='checkbox'
                                                className={`NotifiCheckBox noti1 `}
                                                checked={selectedCheckboxes.includes(element.cassia_tech_id)}
                                                onChange={() => handleCheckboxChange(element.cassia_tech_id)}
                                              />
                                          </div>
                                          <div className='field-element'style={{width:'80%'}}>
                                          {element.tech_name}
                                          </div>
                                      </div>
                                  ))
                              }
                          </div>
                      </div>
                      <div className='bottom-content'>
                             <div className='cont-buton'>
                              {
                                (loading)?<LoadSimple></LoadSimple>:
                                <Action disabled={(selectedCheckboxes.length>0?false:true)} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={()=>{Registrar()}}/>
                              }
                             
                             </div>
                             <div className='cont-buton'>
                              {
                                (loading)?'':
                                <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={()=>{closCreateServiceModal()}}/>
                              }
                             
                             </div>
                      </div>
                  </div>
                                  
              </div>
              </div>
      </div>
  )
}

export default ModalSelectTech